import React from 'react'
import "./Css/Banner.css";


const Banner = ({image, propAlt, bannerTitle, bannerContent, bannerConclude}) => {
  const bannerStyle = {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  return (
    <div className='banner' style={bannerStyle} aria-label={propAlt}>
      <div className='banner-content'>
        <div className='centered-align'>
          <h1>{bannerTitle}</h1>
          {bannerContent?.trim() && (
            <p>
              {bannerContent}
            </p>
          )}          
          {bannerConclude?.trim() && (
            <span className='banner-conclude'>
              {bannerConclude}
            </span>
          )}

        </div>
      </div> 
    </div>
    
  )
}

export default Banner;